import { api, useRoleConf, useSuspenseQuery } from "@pharmupp/p3-front-commons"
import { format } from "date-fns"
import type { ApiAgenda } from "./agenda.model"
import { apiRoleConf } from "./api.roleConf"

export const useAgendaApi = (adherentId?: string) => {
  const { endpoint, queryKey } = useRoleConf(apiRoleConf(adherentId))

  const { data: events = [] } = useSuspenseQuery({
    queryKey,
    queryFn: () => api.get<ApiAgenda[]>(endpoint),
    select: agendaSelect,
  })

  return {
    events,
  }
}

const agendaSelect = (rawData: ApiAgenda[]) =>
  rawData.map((data) => {
    const { startDate, endDate, ...event } = data
    const start = new Date(startDate)
    const end = new Date(endDate)

    return {
      ...event,
      day: format(start, "d"),
      month: start.toLocaleDateString("fr-FR", { month: "short" }),
      startTime: format(start, "HH'h'mm"),
      endTime: format(end, "HH'h'mm"),
    }
  })
